import { useFormContext } from "react-hook-form";
import {
  edsn_Marktrol,
  RegistrationCreateDto,
} from "../../../openapi/edsn-webapi";
import ContactControl from "../ContactControl";
import OptionalContactControl from "../OptionalContactControl";

type contactDetailStepProps = {
  isCreate?: boolean;
};

const ContactDetailStep = ({ isCreate }: contactDetailStepProps) => {
  const { watch } = useFormContext<RegistrationCreateDto>();
  const marketRole = watch("marketRole")
  const isLv = marketRole === edsn_Marktrol.LVLEVERANCIER;
  const isMv = marketRole === edsn_Marktrol.MVMEETVERANTWOORDELIJKE;
  const isPv = marketRole === edsn_Marktrol.PVPROGRAMMAVERANTWOORDELIJKE;
  const isGds = marketRole === edsn_Marktrol.GDSEIGENAAR_GESLOTEN_DISTRIBUTIE_SYSTEEM;
  const isOda = marketRole === edsn_Marktrol.ODAOVERIGE_DIENSTENAANBIEDER;

  return (
    <>
      <ContactControl fieldname="contactDefault" />
      {isLv && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactProcessTransferDifferentThanDefault"
            name="contactProcessTransfer"
            label="contactProcessTransferTitle"
            TooltipTitle="contactProcessTransferTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactAtoDifferentThanDefault"
            name="contactAto"
            label="contactAtoTitle"
            TooltipTitle="contactAtoTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactPeriodicNetworkRatesDifferentThanDefault"
            name="contactPeriodicNetworkRates"
            label="contactPeriodicNetworkRatesTitle"
            TooltipTitle="contactPeriodicNetworkRatesTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactTocDifferentThanDefault"
            name="contactToc"
            label="contactTocTitle"
            TooltipTitle="contactTocTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactCerDifferentThanDefault"
            name="contactCer"
            label="contactCerTitle"
            TooltipTitle="contactCerTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactDisputeProcessDifferentThanDefault"
            name="contactDisputeProcess"
            label="contactDisputeProcessTitle"
            TooltipTitle="contactDisputeProcessTooltipTitle"
          />
        </>
      )}
      {(isLv || isMv || isPv || isGds) && isCreate && (
        <OptionalContactControl
          nameBool="contactSecurityOfSupplyDifferentThanDefault"
          name="contactSecurityOfSupply"
          label="contactSecurityOfSupplyTitle"
          TooltipTitle="contactSecurityOfSupplyTooltipTitle"
        />
      )}
      {(isLv || isMv || isPv) && isCreate && (
        <OptionalContactControl
          nameBool="contactMeteringCorrectionForLargeConsumersDifferentThanDefault"
          name="contactMeteringCorrectionForLargeConsumers"
          label="contactMeteringCorrectionForLargeConsumersTitle"
          TooltipTitle="contactMeteringCorrectionForLargeConsumersTooltipTitle"
        />
      )}
      {(isLv || isGds) && isCreate && (
        <OptionalContactControl
          nameBool="contactSettlementProcessForLargeConsumerMeteringErrorsDifferentThanDefault"
          name="contactSettlementProcessForLargeConsumerMeteringErrors"
          label="contactSettlementProcessForLargeConsumerMeteringErrorsTitle"
          TooltipTitle="contactSettlementProcessForLargeConsumerMeteringErrorsTooltipTitle"
        />
      )}
      {(isLv || isOda) && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactReasonableDoubtDifferentThanDefault"
            name="contactReasonableDoubt"
            label="contactReasonableDoubtTitle"
            TooltipTitle="contactReasonableDoubtTooltipTitle"
          />
        </>
      )}
      {(isLv || isPv || isOda) && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactMajorDisruptionsDifferentThanDefault"
            name="contactMajorDisruptions"
            label="contactMajorDisruptionsTitle"
            TooltipTitle="contactMajorDisruptionsTooltipTitle"
          />
        </>
      )}
      {(isLv || isMv) && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactComplaintsHandlingDifferentThanDefault"
            name="contactComplaintsHandling"
            label="contactComplaintsHandlingTitle"
            TooltipTitle="contactComplaintsHandlingTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactUnfairCustomerDisputeDifferentThanDefault"
            name="contactUnfairCustomerDispute"
            label="contactUnfairCustomerDisputeTitle"
            TooltipTitle="contactUnfairCustomerDisputeTooltipTitle"
          />
        </>
      )}
      {isMv && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactMeasuringDeviceDifferentThanDefault"
            name="contactMeasuringDevice"
            label="contactMeasuringDeviceTitle"
            TooltipTitle="contactMeasuringDeviceTooltipTitle"
          />
        </>
      )}
    </>
  );
};

export default ContactDetailStep;
